var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "splicing-tables",
      class: { splicingTable: _vm.destination },
      attrs: { id: _vm.object.cb_id }
    },
    [
      _c("table-data-object", {
        attrs: {
          "object-name": _vm.getCableIdentification(),
          "is-selected": _vm.isCableSelected(),
          disabled: _vm.disabled,
          side: _vm.side
        },
        on: { click: _vm.selectCable, "open-menu-object": _vm.openCableMenu }
      }),
      _vm._v(" "),
      _c(
        "table",
        _vm._l(_vm.object.fibers, function(fiber, index) {
          return _c(_vm.rowComponent, {
            key: fiber.fb_id,
            tag: "component",
            attrs: {
              "update-counter": _vm.updateCounter,
              "fiber-per-tube-cache": _vm.fibersPerTube,
              index: index + 1,
              "number-in-cable": fiber.fb_nr_in_cable,
              tube: fiber.fb_nr_tube,
              "object-type": "cable",
              "object-name": _vm.getCableIdentification(index),
              "tube-number": _vm.getTubeIdentification(fiber),
              "connection-point-name": "F " + fiber.fb_nr_in_tube,
              state: _vm.getConnectionPointState(fiber, "fb"),
              "tube-color": _vm.getFiberColor(fiber.fb_nr_tube),
              "connection-point-color": _vm.getFiberColor(fiber.fb_nr_in_tube),
              "tube-is-selected": _vm.isTubeSelected(fiber),
              "connection-point-is-selected": _vm.isFiberSelected(fiber),
              disabled: _vm.disabled,
              "connection-type": _vm.getConnectionType(fiber.fb_id)
            },
            on: {
              "select-tube": function($event) {
                return _vm.selectTube(fiber)
              },
              "select-connection-point": function($event) {
                return _vm.selectFiber(fiber, index)
              },
              "open-menu-tube": function($event) {
                return _vm.openTubeMenu($event, fiber)
              },
              "open-menu-connection-point": function($event) {
                return _vm.openConnectionPointMenu($event, fiber, "fb")
              }
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f74b105", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f74b105","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/CableFibers.vue
// module id = null
// module chunks = 